import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

export const useTotalAcctCount = (
  myAccountValue: string,
  accountTypeValue: string,
  checkoutStatus: string
) => {
  const axios = useAxios();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const pubPropertyId = searchParams.get("pid") ?? "";
  const { data, refetch, isFetching } = useQuery({
    queryKey: [
      "investor-account-list-count",
      pubPropertyId,
      myAccountValue,
      accountTypeValue,
      checkoutStatus
    ],
    queryFn: async () => {
      try {
        const view = myAccountValue ?? "ALL ACCOUNTS";
        const acctType = accountTypeValue ?? "FT VERIFIED";
        const searchText = searchParams.get("searchText") ?? "";
        const checkout = checkoutStatus ?? "OFF";

        const urlKey = `${t(
          "investor-account-list-count-api"
        )}?pubPropertyId=${pubPropertyId}&${
          acctType?.length > 0 ? `&acctStatus=${acctType}` : ""
        }${view?.length > 0 ? `&view=${view}` : ""}${
          searchText?.length > 0
            ? `&searchTxt=${encodeURIComponent(searchText)}`
            : ""
        }${
          checkout?.length > 0
            ? `&checkoutStatus=${
                checkout === "CHECKED OUT"
                  ? "CHECKED OUT ONLY"
                  : checkout === "AVAILABLE"
                  ? "AVAILABLE ONLY"
                  : "ALL"
              }`
            : ""
        }`;

        const response = await axios.get(urlKey);
        return {
          ...response?.data?.data
        };
      } catch (error) {
        console.error("Error fetching flipper vault data:", error);
        return {
          totalRecords: 0
        };
      }
    },
    placeholderData: (previousData) => previousData
  });

  return { data: data, refetch, isFetching };
};
